module.exports = __webpack_public_path__ + "static/media/cooking-ma.30709ab3.png";